module.exports = __webpack_public_path__ + "static/media/mobile4.24aa8434.png";